import { spaceOf } from "./useCases";

/**
 * What a room booking request carries by use case — the answers the request
 * flows used to give by name (`=== "venue"`), pinned in
 * `util/__tests__/roomRequestShape.test.ts`. Both reservation flows read them,
 * so the request a venue sends and the reservation a venue pays for stay alike.
 */

/** Does the request stamp the picked start and end times? Rooms booked by the hour. */
export const requestCarriesTimeOfDay = (useCase: string | null | undefined): boolean =>
  spaceOf(useCase)?.timeUnit === "hour";

/** Does the request send the event type? The use cases that ask for the event. */
export const requestCarriesEventType = (useCase: string | null | undefined): boolean =>
  spaceOf(useCase)?.eventTypes === true;

/** The price unit a room card shows after "from …": per day for hourly rooms, else per night. */
export const roomPriceUnitKey = (useCase: string | null | undefined): "apartment.day" | "apartment.night" =>
  requestCarriesTimeOfDay(useCase) ? "apartment.day" : "apartment.night";
